<template>
  <div style="display: flex; flex-direction: column; gap: 20px">
    <PasswordInput
      id="password"
      :field="$v.form.password"
      :state="validateState($v.form, 'password')"
      :server-errors="serverErrors['password']"
      @update="$v.form.password.$model = $event"
      @keyupEnter="submitForm"
      label="New password"
      field-name="password"
    />
    <PasswordInput
      id="passwordRepeat"
      :field="$v.form.repeatPassword"
      :state="validateState($v.form, 'repeatPassword')"
      :server-errors="serverErrors['repeatPassword']"
      @update="$v.form.repeatPassword.$model = $event"
      @keyupEnter="submitForm"
      label="Re-enter new password"
      field-name="password"
    />
    <SubmitButton
      text="Confirm"
      class="mt-4"
      :loading="loading"
      @click.native="submitForm"
    />
  </div>
</template>

<script>
import PasswordInput from "@/components/inputs/PasswordInput";
import setPassword from "@/mixins/loopLogin/setPassword";
import SubmitButton from "@/components/buttons/SubmitButton";
export default {
  name: "SetNewPassword",
  components: { SubmitButton, PasswordInput },
  mixins: [setPassword],
};
</script>
